/**
 * Horizontal bleed + matching padding inside already-padded shells (App header, Home column).
 * Gives ring/outline/hover shadow and slight translate-y room without shrinking the readable column width.
 *
 * Uses negative mx so net layout width stays aligned with sibling content; paired px absorbs overflow paint.
 */
export const interactiveBleedInsetX =
  '-mx-2 px-2 sm:-mx-2.5 sm:px-2.5 md:-mx-3 md:px-3';
